window.addEventListener('unhandledrejection', function(event) {
  console.error('error unhandledrejection :', event.reason);
});

import('./bootstrap')
        .catch(err => console.error(err));
